import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MENU_ITEMS } from '../../config/menu/menu-config';
import { LoginService } from 'src/app/services/login.service';
import { MenuItem } from '../../models/menu-item/menu-item.model';
import { FiltrarProyectosService } from 'src/app/services/filtrar-proyectos.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})

export class NavbarComponent {
  // Para agregar nueva pestaña en el menu se tiene que agregar al objeto 
  menus: MenuItem[] = MENU_ITEMS;

  rol: string = '';
  username: string = '';
  mostrarMenu: MenuItem[] = [];
  currentUrl: string = '';

  public roles_nombres: any;
  public roles_seleccionados: any;
  public estamos: any = null;

  constructor(
    private router: Router,
    private loginService: LoginService,
    private filtrarProyectosService: FiltrarProyectosService 
  ) { }


  ngOnInit() {
    this.obtenerURL();
    this.getUserNameRol();
    this.identificar();
  }
  
  identificar(){
    this.estamos = environment.production ? null : 'Desarrollo';
  }

  obtenerURL() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const urlSinParametros = event.urlAfterRedirects.includes('?') 
          ? event.urlAfterRedirects.split('?')[0] 
          : event.urlAfterRedirects;
      this.currentUrl = urlSinParametros;
      }
    });
  }

  isActive(menuUrl: any): boolean {
    if (!menuUrl || !this.currentUrl) return false;
    const urlParts = this.currentUrl.split('/');
    if (urlParts.length > 1) {
      const baseCurrentUrl = urlParts[1].replace(/D\d*$/, '');
      return baseCurrentUrl === menuUrl.replace('/', '');
    }
    return false;
  }

  isSubMenuActive(menuUrl: any | undefined): boolean {
    if (!menuUrl) return false; // Maneja el caso cuando menuUrl es undefined
    return this.mostrarMenu.some(menu =>
      menu.subMenu && menu.subMenu.some(subMenu =>
        subMenu.url ? this.currentUrl.includes(subMenu.url) : false // Verifica que subMenu.url no sea undefined
      )
    );
  }

  hasActiveSubMenu(subMenus: any[]): boolean {
    if (!subMenus) return false;
    return subMenus.some(subMenu => this.isActive(subMenu.url));
  }

  saberRol(){
    const { rol } = this.filtrarProyectosService.validacionUsuarios();

    let rolesString = localStorage.getItem('roles_nombre') || '';
    // Convierte el string de roles a un array de strings, quitando espacios extra
    this.roles_nombres = rolesString.split(',').map((role: string) => role.trim());
    this.roles_seleccionados = localStorage.getItem('roles_seleccionados') || '';

    if (rol === 'Administrador') {
      this.rol = rol;
    } else {
      if (this.roles_nombres.length === 1) {
          this.rol = this.roles_nombres[0];
      } else {
          this.rol = 'Varios roles seleccionados';
      }
    }
  }

  getUserNameRol() {
    // Obtiene el rol del ID
    let idSeleccion = localStorage.getItem('rol_id') || '';

    // Si el rol id = 14, entonces son varios roles seleccionados
    if (idSeleccion === '14') {
      this.saberRol();
    } else {
      // Si el rol id != 14, entonces se coloca el rol ya obtenido
      this.rol = localStorage.getItem('rol')|| '';
      // Asegura que roles_nombres sea un array incluso si hay un solo rol
      this.roles_nombres = [this.rol];
    }

    this.username = localStorage.getItem('username') || '';
    this.crearNavegacion();
  }

  crearNavegacion() {
    // Filtramos los menús según los roles disponibles
    this.mostrarMenu = this.menus
      .filter(menu => this.esVisible(menu))
      .map(menu => this.agregarsubMenus(menu));
  }

  esVisible(menu: MenuItem): boolean {
    // Especifica que los rolesPermitidos pueden ser 'todos' o un array de strings
    const rolesPermitidos: string[] | 'todos' = menu.validacion?.roles;

    // Si los roles permitidos son 'todos', muestra el menú
    if (rolesPermitidos === 'todos') {
      return true;
    }

    // Verifica si alguno de los roles del usuario coincide con los roles permitidos del menú
    return Array.isArray(rolesPermitidos) && this.roles_nombres.some((rol: string) => rolesPermitidos.includes(rol));
  }

  agregarsubMenus(menu: MenuItem): MenuItem {
    if (menu.subMenu) {
      // Recursivamente filtra y agrega los submenús que sean visibles
      menu.subMenu = menu.subMenu
        .filter(subMenu => this.esVisible(subMenu))
        .map(subMenu => this.agregarsubMenus(subMenu));
    }
    return menu;
  }


  logout() {
    this.loginService.logout()
  }

}
